import React from 'react';
import {useTranslation} from 'react-i18next';

type SectionProcedureProps = {
    procedure: string | null;
}

const SectionProcedure: React.FC<SectionProcedureProps> = ({procedure}) => {
    const {t} = useTranslation();

    if (!procedure) {
        return <div className="procedure-text">{t('specificationViewer.noProcedure')}</div>;
    }

    return <div className="procedure-text">{procedure}</div>;
};

export default SectionProcedure;
